import WorkspaceModel from './WorkspaceModel';

export default class GraphModel {
    parent: WorkspaceModel | null;
    label: string;
    leaf: boolean = true;
    selectable: boolean = true;
    key: string;

    constructor(parent: WorkspaceModel, data: object) {
        this.parent = parent;
        this.label = data.name
        this.key = parent.id + '_' + data.id;

        // create all properties from data, except the two that would break the tree:
        // `parent` is the link established above, and a graph is always a leaf.
        // WorkspaceModel excludes the same pair — WorkspaceSerializer really does emit a
        // `parent` field, so the guard matters as soon as GraphSerializer gains one.
        for (const [key, value] of Object.entries(data)) {
            if (key !== 'children' && key !== 'parent') {
                this[key] = value;
            }
        }
    }
}